var cov_u3grf65nj = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Pagination/styles/index.js",
      hash = "dd6b230237edb363687d509e1e6fea8218ce3a07",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Pagination/styles/index.js",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 31
        },
        end: {
          line: 5,
          column: 71
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var paginationLess = {};
import genaration from '../../utils/classname';
export var paginationClass = (cov_u3grf65nj.s[0]++, genaration(paginationLess, 'pagination'));